import React, { useRef } from "react";
import { rem } from "polished";
import styled, { css } from "styled-components";
import mq from "../../../helpers/media-queries";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import Left from "../../../assets/img/arrow-left-small.png";
import Right from "../../../assets/img/arrow-right.png";
import Cube from "../../../assets/img/cube.png";
import Circle from "../../../assets/img/360.png";

// Import Swiper styles
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";

SwiperCore.use([Navigation, Pagination]);

const SlidesContainer = styled.div`
	color: black;
	padding: 0 ${rem(16)};
	position: relative;
	z-index: 0;

	${mq("sm", "min")} {
		display: none;
	}

	.swiper-slide {
		height: auto;

		img {
			width: 100%;
			cursor: pointer;
			height: 100%;
			object-fit: cover;
		}
	}

	.swiper-pag {
		position: static;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.swiper-pagination-bullet {
		width: 10px;
		height: 10px;
		background: linear-gradient(180deg, #f5f6f8 0%, #eeeff1 100%);
		border: 1px solid #aeb1b7;
		border-radius: 50%;
		opacity: 1;
		margin: 0 ${rem(4)};
	}
	.swiper-pagination-bullet-active {
		background: #433129;
	}
`;
const ThreeSixty = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 50%;
	border: 1px solid #c9c9c9;
	position: absolute;
	right: 20px;
	top: -10px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	z-index: 3;
	padding: 5px;
	background-color: #fff;

	img {
		width: 90%;
	}
`;

const Controls = styled.div`
	display: flex;
	justify-content: space-around;
	color: black;
	margin: 8px 0;

	img {
		width: 8px;
	}
`;

const SliderButton = styled.a`
	background: linear-gradient(180deg, #f5f6f8 0%, #eeeff1 100%);
	border: 1px solid #aeb1b7 !important;
	border-radius: 4px;
	padding: ${rem(9)} ${rem(11)} !important;
	margin: 0 auto;
	font-weight: 400;
	font-size: 15px;
	color: #433129;
	display: block;
	margin-top: ${rem(20)};
	margin-bottom: ${rem(45)};
	display: flex;
	align-items: center;
	text-decoration: none;
	font-family: sans-serif;
	position: relative;

	&::after {
		content: "";
		position: absolute;
		right: 15px;
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 7.5px 0 7.5px 7px;
		border-color: transparent transparent transparent #433129;
	}

	img {
		width: 20px;
		margin-right: 10px;
	}
`;

const Slider = ({ data, setPopupOpen, setInitialSlide, buttonLink, color }) => {
	const prevRef = useRef(null);
	const nextRef = useRef(null);

	function showImage(item) {
		let img;
		if (color === 1 && item.secondImage) {
			img = item.secondImage;
		} else {
			img = item.image;
		}
		return img;
	}

	return (
		<SlidesContainer>
			<ThreeSixty onClick={() => setPopupOpen("360")}>
				{" "}
				<img src={Circle} alt="" />{" "}
			</ThreeSixty>
			<Swiper
				// navigation
				spaceBetween={35}
				pagination={{ clickable: true, el: ".swiper-pag" }}
				slidesPerView={1}
				onInit={(swiper) => {
					swiper.params.navigation.prevEl = prevRef.current;
					swiper.params.navigation.nextEl = nextRef.current;
					// sswiper.navigation.update();wiper.navigation.init();
					//
				}}
				// style={{ display: "none" }}
			>
				{data.map((item, index) => (
					<SwiperSlide key={index} onClick={() => setInitialSlide(index)}>
						<img
							src={showImage(item)}
							alt=""
							onClick={() => {
								setPopupOpen("slider");
							}}
						/>
					</SwiperSlide>
				))}
				<Controls>
					<div ref={prevRef}>
						<img src={Left} alt="" />
					</div>
					<div className="swiper-pag"></div>
					<div ref={nextRef}>
						<img src={Right} alt="" />
					</div>
				</Controls>
			</Swiper>
			<SliderButton href={buttonLink}>
				<img src={Cube} alt="" /> <span>See how it looks in Your Garden</span>
			</SliderButton>
		</SlidesContainer>
	);
};

export default Slider;
